import { useQuery } from "@tanstack/react-query";
import { SessionService } from "@/services/brain/SessionService";

export const useSessions = (
  userId: string,
  options: { limit?: number; offset?: number; search?: string } = {},
) => {
  return useQuery({
    queryKey: ["brain", "sessions", userId, options.limit, options.offset, options.search],
    queryFn: () => SessionService.getSessions(userId, options),
    enabled: !!userId,
    staleTime: 30 * 1000,
  });
};
